import { AfterViewInit, Component, Inject, OnDestroy, OnInit, QueryList, ViewChild, ElementRef } from '@angular/core';
import { data2 } from '../topnavigation/topnavigation';
import { TopmenuService } from '../topnavigation/topmenu.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonModule, DOCUMENT } from '@angular/common';
import { GeolocationService } from '@ng-web-apis/geolocation';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { UrlParamsPipe } from '../../utilities/url-params.pipe';
import { PosthogService } from '../../services/posthog.service';

@Component({
  selector: 'app-topnavigation',
  templateUrl: './topnavigation.component.html',
  styleUrls: ['./topnavigation.component.scss'],
  imports: [
    CommonModule, 
    RouterModule, 
    FormsModule,
    UrlParamsPipe
  ],
})
export class TopnavigationComponent implements OnInit, OnDestroy {
  navmainuData: any = data2;
  data: any;
  headerNavData: any;
  subscriptions: Subscription[];
  active = 'tab_1';
  public isCollapsed = false;
  currentAccord: number = 0;
  hideMainNav = false;
  hideNaveFor = ['www.vertofx.ae'];
  currentLocation: any;
  latitude: number | null = null;
  longitude: number | null = null;
  queryParams: any;
  @ViewChild('paramsLink') paramsLink: any;
  @ViewChild('loginLink') loginLink: any;
  @ViewChild('openPageLink',{ read: ElementRef }) openPageLink: QueryList<ElementRef> | any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private topMenuService: TopmenuService,
    private router: Router,
    private readonly geolocation$: GeolocationService,
    private route: ActivatedRoute,
    private posthogService: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  
  ngOnDestroy(): void {
    
    
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
  ngOnInit(): void {
    this.topMenuService.gettopMenuData();
    this.topMenuService.topMenu$.subscribe(data => {
      // geolocation.getCurrentPosition(this.error, this.success)
      if (data != null) {
        this.headerNavData = {
          button1: {
            text: data?.button[0]?.fields?.buttonText || '',
            url: data?.button[0]?.fields?.redirectLink || '',
            target: data?.button[0]?.fields?.actionType || '',
          },
          button2: {
            text: data?.button[1]?.fields?.buttonText || '',
            url: data?.button[1]?.fields?.redirectLink || '',
            target: data?.button[1]?.fields?.actionType || '',
          },
          brand: {
            img: data?.navHeaderLogo?.fields?.file?.url || '',
            alt: data?.navHeaderLogo?.fields?.title || '',
            link: data?.navHeaderLogoLink || '',
            logoAction: data?.navHeaderLogoActionType || '',
          },
          brandLink: {},
          menu: data?.navHeaderColumn,
          productAnnouncements:
            data?.navHeaderColumn[0]?.fields?.productAnnouncements,
        };
      }
    });
  }
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
        },
        error => {}
      );
    } else {
    }
  }
  success(position: any) {}
  error() {
    alert('Sorry, no position available.');
  }
  sliceIntoChunks(arr: any, chunkSize: any) {
    const res: any[] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk as never);
    }
    return res;
  }

  getCombinedHeaderSubsectionReferences(mainmenu: any): any[] {
    const combinedReferences = [
      ...(mainmenu?.fields?.headerSubsectionReference || []),
      ...(mainmenu?.fields?.headerSubsectionReference2 || []),
      ...(mainmenu?.fields?.headerSubsectionReference3 || []),
    ];

    return combinedReferences;
  }

  newUi() {
    this.router.navigateByUrl('');
  }

  slideAccordion(ind: number) {
    this.currentAccord === ind
      ? (this.currentAccord = -1)
      : (this.currentAccord = ind);
  }

  openLink(link: any, title?: string) {
    if (link == '') {
      return;
    } else {
      window.open('pricing', '_self');
    }

    if (title === 'Pricing') {
      window.open('pricing', '_self');
    } else if (title === 'Developers') {
      window.open('https://docs.vertofx.com', '_self');
    }
    return;
  }
  openLink2(event:any, openPageLink: any){
    event.preventDefault();
    const link = openPageLink.href;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, '_self');
  }
  goLink(link: any, target: any) {
    if (link == '') {
      return;
    } else {
      window.open(link, target);
    }
  }
  onMouseOver(item: any) {
    this.active = item.parentElement.id;
  }
  onMouseOverRoot(item: any) {
    let _item = item?.parentElement.querySelectorAll('div.sub_menu ul li')[0];
    this.active = _item?.id;
  }

  openDocs() {
    window.open('https://docs.vertofx.com', '_blank');
  }
  toggleMenu() {
    let element = this.document.getElementsByClassName('nav-left')[0];
    let bodyElement = this.document.getElementsByTagName('body')[0];
    element.classList.toggle('show');
    bodyElement.classList.toggle('no-scroll');
  }

  /**
   * Tracks login button click
   */
  onLoginClick(): void {
    this.posthogService.captureLoginClick({ 
      location: 'header',
      destination_url: this.headerNavData?.button1?.url 
    });
  }

  /**
   * Tracks get started CTA click
   */
  onGetStartedClick(): void {
    this.posthogService.captureCTAClick('get_started', 'header', {
      ctaText: this.headerNavData?.button2?.text,
      destinationUrl: this.headerNavData?.button2?.url
    });
  }

  /**
   * Tracks navigation menu item clicks
   */
  onNavItemClick(mainMenuTitle: string, subMenuTitle: string, url?: string, category?: string): void {
    const normalizedMenu = mainMenuTitle.toLowerCase().replace(/\s+/g, '_');
    const normalizedItem = subMenuTitle.toLowerCase().replace(/\s+/g, '_');
    this.posthogService.captureNavClick(normalizedMenu, normalizedItem, {
      itemCategory: category,
      destinationUrl: url
    });
  }
  
}
